export const getCspNonce = () => {
  return document.querySelector<HTMLMetaElement>('meta[name="csp-nonce"]')?.content;
};
